"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Axios = require("axios");
var React = require("react");
var ReactDOM = require("react-dom");
var input_form_1 = require("./components/input-form");
var env_1 = require("./env");
var VALIDATE_TYPE = input_form_1.default.VALIDATE_TYPE;
var ERROR_MESSAGE_TYPE = input_form_1.default.ERROR_MESSAGE_TYPE;
/**
 * ## アカウント登録関連のエラー
 */
var RegisterError = (function () {
    function RegisterError(message) {
        this.message = message;
        this.name = 'RegisterError';
        this.support = '何度か試しても失敗する場合は<a href="https://ekiworld.net/contact/enterprize_after.html" target="_blank">お問い合わせフォーム</a>よりご連絡ください。';
    }
    RegisterError.prototype.toString = function () {
        return this.name + ': ' + this.message + this.support;
    };
    return RegisterError;
}());
var URL = {
    new: { method: 'get', url: '/accounts/new.json' },
    create: { method: 'post', url: '/accounts.json' },
};
/*
 * ## アカウントの新規登録フォームコンポーネント
 */
var Register = (function (_super) {
    __extends(Register, _super);
    function Register() {
        var _this = _super.call(this) || this;
        _this.data = {
            message: 'アカウントの新規登録',
            inputTexts: [
                {
                    label: 'Eメールアドレス',
                    name: 'email',
                    value: '',
                    type: 'email',
                    icon: 'glyphicon glyphicon-envelope',
                    description: 'Eメールアドレスがアカウント名となります。',
                    setValue: function (value) {
                        _this.setValue('email', value);
                        _this.validate('email', [VALIDATE_TYPE.EXIST]);
                    },
                },
                {
                    label: 'パスワード',
                    name: 'password',
                    value: '',
                    type: 'password',
                    icon: 'glyphicon glyphicon-lock',
                    description: '英大文字・英小文字・数字・記号をそれぞれ1文字以上含んだ、半角8文字以上にする必要があります。<br>' +
                        '使用できる記号は^ $ * . [ ] { } ( ) ? - " ! @ # % & / , > < ‘ : ; | _ ~ `になります。',
                    setValue: function (value) {
                        _this.setValue('password', value);
                        _this.validate('password', [VALIDATE_TYPE.EXIST]);
                    },
                },
                {
                    label: 'パスワード（確認用）',
                    name: 'passwordConfirmation',
                    value: '',
                    type: 'password',
                    placeholder: 'パスワードと同じ文字列',
                    icon: 'glyphicon glyphicon-log-in',
                    setValue: function (value) {
                        _this.setValue('passwordConfirmation', value);
                        _this.validate('passwordConfirmation', [
                            VALIDATE_TYPE.EXIST,
                            [VALIDATE_TYPE.SAME, 'password'],
                        ]);
                    },
                },
                {
                    label: '企業アカウント',
                    name: 'loginId',
                    type: 'text',
                    value: '',
                    placeholder: '別途ご連絡している企業アカウント',
                    icon: 'fa fa-key',
                    description: '登録時のみ必要となります。<br>別途ご連絡しております。ご不明な場合は弊社担当までご連絡ください。',
                    setValue: function (value) {
                        _this.setValue('loginId', value);
                        _this.validate('loginId', [VALIDATE_TYPE.EXIST]);
                    },
                },
                {
                    label: '登録キー',
                    name: 'apiKey',
                    value: '',
                    type: 'text',
                    placeholder: '別途ご連絡している登録キー',
                    icon: 'fa fa-key',
                    description: '登録時のみ必要となります。<br>別途ご連絡しております。ご不明な場合は弊社担当までご連絡ください。',
                    setValue: function (value) {
                        _this.setValue('apiKey', value);
                        _this.validate('apiKey', [VALIDATE_TYPE.EXIST]);
                    },
                },
            ],
            buttons: [
                {
                    name: 'dummy',
                    text: '',
                    size: '8',
                },
                {
                    name: 'ok',
                    text: '仮登録',
                    size: '4',
                    call: function () {
                        _this.validate('email', [VALIDATE_TYPE.EXIST]);
                        _this.validate('password', [VALIDATE_TYPE.EXIST]);
                        _this.validate('passwordConfirmation', [
                            VALIDATE_TYPE.EXIST,
                            [VALIDATE_TYPE.SAME, 'password'],
                        ]);
                        _this.validate('loginId', [VALIDATE_TYPE.EXIST]);
                        _this.validate('apiKey', [VALIDATE_TYPE.EXIST]);
                        _this.setState(function (state) {
                            if (state.processing) {
                                return state;
                            }
                            var hasError = false;
                            for (var key in state.inputTexts) {
                                if (state.inputTexts[key].errorMessage) {
                                    hasError = true;
                                }
                            }
                            if (hasError) {
                                state.errorMessage = {
                                    text: 'エラーとなっている項目をご確認ください。',
                                    type: ERROR_MESSAGE_TYPE.VALIDATE,
                                };
                                return state;
                            }
                            _this._body.account.name = state.inputTexts.email.value.trim();
                            _this._body.account.email = _this._body.account.name;
                            _this._body.account.password = state.inputTexts.password.value;
                            _this._body.account.organization.name = state.inputTexts.loginId.value;
                            _this._body.account.organization.apiManagementAccount.loginId = _this._body.account.organization.name;
                            _this._headers['X-EkispertAdminAPIKey'] = state.inputTexts.apiKey.value;
                            if (!_this.submittable) {
                                return state;
                            }
                            _this._agent.request(Object.assign({}, URL['create'], { headers: _this._headers, data: _this._body })).then(function (res) {
                                window.location.href = './verification.html';
                            }).catch(function (reason) {
                                _this.setState(function (s) {
                                    var serverErrorMessage = {
                                        text: '登録に失敗しました。もう一度登録ボタンを押してください。何度か試しても失敗する場合は' +
                                            '<a href="https://ekiworld.net/contact/enterprize_after.html" target="_blank">お問い合わせフォーム</a>よりご連絡ください。' +
                                            'その際、登録に利用したEメールアドレス、エラーが発生したURL、エラー内容をお知らせください。',
                                        type: ERROR_MESSAGE_TYPE.SERVER,
                                    };
                                    if (reason.response) {
                                        var status_1 = reason.response.status;
                                        if (status_1 >= 400 && status_1 < 500) {
                                            var statuses = reason.response.data.resultSet.statuses;
                                            var message_1 = '入力された値をお確かめください。';
                                            if (Array.isArray(statuses)) {
                                                statuses.forEach(function (status) {
                                                    message_1 += "(" + status.messages + ")";
                                                });
                                            }
                                            s.errorMessage = {
                                                text: message_1, type: ERROR_MESSAGE_TYPE.CLIENT,
                                            };
                                        }
                                        else if (status_1 >= 500) {
                                            s.errorMessage = serverErrorMessage;
                                        }
                                    }
                                    else {
                                        s.errorMessage = serverErrorMessage;
                                    }
                                    s.processing = false;
                                    return s;
                                });
                            });
                            state.processing = true;
                            return state;
                        });
                    },
                },
            ],
            description: '仮登録が完了すると、入力したＥメールアドレスに「【駅すぱあとWebサービス】 検証コード」という件名のメールが届きます。' +
                'メールに記載されている検証コードを次の画面で入力してください。',
        };
        _this.state = {
            inputTexts: _this.data.inputTexts.reduce(function (obj, inputText) {
                obj[inputText.name] = {
                    label: inputText.label,
                    value: inputText.value,
                    errorMessage: inputText.errorMessage,
                };
                return obj;
            }, {
                email: null,
                password: null,
                passwordConfirmation: null,
                loginId: null,
                apiKey: null,
            }),
            errorMessage: _this.data.errorMessage,
            processing: false,
        };
        _this._agent = Axios.create({
            baseURL: env_1.default.ConnectSetting.baseURL,
            withCredentials: true,
            responseType: 'json',
        });
        _this._headers = {};
        _this._body = {
            account: {
                organization: {
                    apiManagementAccount: {
                        apiManagementProvider: {},
                    },
                },
            },
        };
        _this.getEditData();
        return _this;
    }
    Object.defineProperty(Register.prototype, "submittable", {
        // アカウント生成APIにsubmit可能かどうか
        get: function () {
            return (Object.keys(this._headers).length > 0 &&
                this._body.account.organization.apiManagementAccount.apiManagementProvider.id !== undefined);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * ### アカウント作成に必要な情報の取得
     */
    Register.prototype.getEditData = function () {
        var _this = this;
        this._agent.request(URL['new']).then(function (res) {
            var resultSet = res.data['resultSet'];
            if (resultSet === undefined) {
                throw _this.accountResponseError('resultSet');
            }
            var links = resultSet.links;
            if (!Array.isArray(links) || links[0] === undefined) {
                throw _this.accountResponseError('links');
            }
            var headerSchema = links[0].headerSchema;
            if (headerSchema === undefined) {
                throw _this.accountResponseError('headerSchema');
            }
            var properties = headerSchema.properties;
            if (properties === undefined) {
                throw _this.accountResponseError('properties');
            }
            _this._headers = {};
            for (var key in properties) {
                if (properties.hasOwnProperty(key) &&
                    Array.isArray(properties[key].enum)) {
                    _this._headers[key] = properties[key].enum[0];
                }
            }
            // 本当はjsonSchemaから情報を取り出す処理にすべきだが、
            // 必要な要素が分かっているのでダイレクトに取得を試みる
            try {
                _this._body.account.organization.apiManagementAccount.apiManagementProvider.id =
                    links[0].schema.properties.account.properties.organization.
                        properties.apiManagementAccount.properties.apiManagementProvider.
                        oneOf[0].properties.id.enum[0];
            }
            catch (e) {
                throw _this.accountResponseError('apiManagementProvider');
            }
        }).catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState(function (state) {
                    if (err.response) {
                        state.errorMessage = {
                            text: 'サーバエラー: ' + err.response.data,
                            type: ERROR_MESSAGE_TYPE.SERVER,
                        };
                        console.error({
                            status: err.response.status,
                            body: err.response.data,
                        });
                    }
                    else {
                        state.errorMessage = {
                            text: err.message,
                            type: ERROR_MESSAGE_TYPE.SERVER,
                        };
                        console.error('Error', err.message);
                    }
                    return state;
                });
                return [2 /*return*/];
            });
        }); });
    };
    /**
     * ### レスポンス構造についてのエラー
     */
    Register.prototype.accountResponseError = function (key) {
        return new RegisterError('サーバーエラー: レスポンスに"' + key + '"がありません。');
    };
    return Register;
}(input_form_1.default.InputForm));
exports.Register = Register;
ReactDOM.render(React.createElement(Register, null), document.getElementById('register'));



//////////////////
// WEBPACK FOOTER
// ./build/js/register.js
// module id = 0
// module chunks = 5